// extracted by mini-css-extract-plugin
export default {"title":"Title_title__MxNSH","small":"Title_small__4m6ja","medium":"Title_medium__k19AX","large":"Title_large__baYb+"};